export default __webpack_public_path__ + "static/media/PAFI_Annual Report 2018.2cda5341.pdf";